import { useEditorContext } from "shared/components/EditorContext"
import { Editor } from "shared/hubrise/editor"
import { ICatalog } from "shared/hubrise/models"

interface UseEditor {
  editor: Editor
  catalog: ICatalog
  onChange: () => void
  refetchCatalog: () => Promise<void>
  isFetching: boolean
}

const useEditor = (): UseEditor => {
  const { editor, onChange, refetchCatalog, isFetching } = useEditorContext()
  return { editor, catalog: editor.catalog, onChange, refetchCatalog, isFetching }
}

export default useEditor
